var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTribal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20028,
    height: 32769,
    viewBox: "0 0 20028 32769",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32082,
    height: 52493.9,
    transform: "scale(0.624225)",
    fill: "#0041ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_25923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7611.73 23775.4L8310.84 26126.5L9857.15 27164.1L7558.61 28648C7558.61 28648 6620.2 30560.8 6517.72 30476.9C6415.25 30393 5219.84 29414.6 5219.84 29414.6L4714.06 27802.6L5568.23 27246.9L6022.86 26273.5L5374 25742.3L3935 25967.1L3543.87 25190.6L4537.89 24464.1L4746.25 23721.9L3116.6 21532.1L5484.17 16967.6L4934.75 16175.5L5888.54 14731.6L5735.63 13106.6L6926.21 12557.9L5420.68 10355.8L5976.89 9327.96L5818.79 8057.8L6788.14 6455.69L6241.94 4753.79C6241.94 4753.79 7350.43 5490.1 7434.31 5387.62C7518.19 5285.14 8055.63 4698.34 8139.5 4595.86C8223.38 4493.39 7664.67 3294.58 7664.67 3294.58L8546.74 2704.74L9366.39 3375.77L10385.5 2270.68L13270.1 3833.44L12816.3 4945.15L13878.2 6156.66L14042.3 7488.89L15920.9 8399.21L15740.1 10989.1L16357.7 12464.4L15127.4 14594.5L16888.1 14952.1L16608.4 15921L13971.7 16842.6L12250.6 19084.2L10818.4 21391.2L8830.75 22216.7L7611.91 23775.2L7611.73 23775.4Z",
    fill: "#FF600F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7542.7 10980.5L11292.4 12216.9L12771.5 11866L13292.8 11348.4L15269.8 11198.2L14464.2 9934.98L12803.5 10290.9L11173.8 8257.75L7306.98 9798.16L7542.7 10980.5Z",
    fill: "#0041ED"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_67_25923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6605.41 21461.5L8675.42 20815.6L8197.25 19168.4L9932 17049.3L11367.5 18224.4L12850.5 16412.9L11722.7 14861.8L7847.43 14086.9L6152.55 18179.5L6605.41 21461.5Z",
    fill: "#0041ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_25923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22061.8,
    height: 45190.3,
    fill: "white",
    transform: "translate(3116.61 2270.68) scale(0.624225)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_67_25923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10730,
    height: 11814,
    fill: "white",
    transform: "translate(6152.55 14086.9) scale(0.624225)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTribal);
export default __webpack_public_path__ + "static/media/Tribal.ad17287203db9f61c63a680de766da20.svg";
export { ForwardRef as ReactComponent };